export class Territory {
  public constructor() {

  }

  public TerritoryCode: string;


  public TerritoryName: string;


  public ServiceRep: string;
}
